import React, { useState, useEffect } from "react";
import { Alert, Spinner } from "reactstrap";
import GudangDashboard from "./components/GudangDashboard";
import PuskesmasDashboard from "./components/PuskesmasDashboard";
import UnitDashboard from "./components/UnitDashboard";

/**
 * Dashboard Component dengan routing berdasarkan status user
 * - Gudang: status == 1 (tingkat tertinggi)
 * - Puskesmas: status == 2
 * - Unit/PUSTU: status == 3
 */
export default function DashboardLevel() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    setCurrentUser(user);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="text-center p-5">
        <Spinner color="primary" />
        <p className="mt-3">Memuat dashboard...</p>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <Alert color="danger">User tidak ditemukan. Silakan login kembali.</Alert>
    );
  }

  const status = currentUser?.status;

  // Routing berdasarkan status user
  if (status == 1) {
    // Dashboard Gudang (status = 1)
    return <GudangDashboard currentUser={currentUser} />;
  } else if (status == 2) {
    // Dashboard Puskesmas (status = 2)
    return <PuskesmasDashboard currentUser={currentUser} />;
  } else if (status == 3) {
    // Dashboard Unit/PUSTU (status = 3)
    return <UnitDashboard currentUser={currentUser} />;
  } else {
    // Fallback jika status tidak dikenal
    return (
      <Alert color="warning">
        Status user tidak dikenali. Silakan hubungi administrator.
      </Alert>
    );
  }
}
